RivalIQ.module('views', function (views, App, Backbone, Marionette, $, _) {
    'use strict';

    // This mixin adds clearfix elements in an effort to preserve
    // rows in the case of varying col heights. The current implementation is quite
    // naive, assuming fixed column widths and that all elements are buffered
    views.rowNormalizer = {
        attachHtml: function (collectionView, childView, index) {
            const me = this;

            const colWidth = me.getOption('colWidth');
            const adjustedIndex = index + Math.floor(index / colWidth);
            if (index && index % colWidth === 0) {
                const view = new Marionette.ItemView({
                    template: false,
                    className: 'clearfix'
                });

                if (collectionView.isBuffering) {
                    collectionView._bufferedChildren.splice(adjustedIndex, 0, view);

                    // add to children so it can be destroyed on render
                    this.children.add(view);
                }
            }

            Marionette.CollectionView.prototype.attachHtml.call(me, collectionView, childView, adjustedIndex);
        }
    };
});
